<script setup lang="ts">
import AppText from '~/components/common/AppText.vue'
import Gallery from '~/components/home/Gallery.vue'
import HeroGallery from '~/components/home/HeroGallery.vue'

const heroImages = [
	{
		title: 'Heizungs-Check starten',
		imgSrc: '/img/heizungs_check_banner.jpg',
	},
	{
		title: 'PV-Check starten',
		imgSrc: '/img/pv_check_banner.jpg',
	},
	{
		title: 'Sanierungs-Check starten',
		imgSrc: '/img/sanierung_check_banner.jpg',
	},
]
</script>

<template>
	<div>
		<section>
			<h1 class="text-4xl md:text-5xl">EnergieKompass</h1>
			<AppText id="TBS24" class="block pt-8 text-xl md:text-2xl" />

			<RouterLink
				:to="{ name: 'address' }"
				class="my-6 mt-6 inline-block w-[100%] md:my-0 md:hidden"
				aria-label="'Öffnen der Adresssuche'"
			>
				<div
					class="bottom-12 right-8 flex justify-between gap-2 whitespace-nowrap bg-land-red px-4 py-2 text-lg font-bold text-white md:max-w-[480px] md:gap-4 md:px-6 md:text-xl"
				>
					<div>Los, Heizungs-Check starten</div>
				</div>
			</RouterLink>

			<RouterLink class="relative my-12 hidden md:block" :to="{ name: 'address' }">
				<HeroGallery :images="heroImages" />
			</RouterLink>
		</section>

		<section class="mb-12">
			<div class="flex flex-col items-stretch gap-8 md:flex-row md:gap-12">
				<div class="flex-1">
					<h4 class="mb-4 text-3xl">Heizungs-Check</h4>

					<AppText id="TBS26" class="block text-lg md:text-lg" />

					<RouterLink
						:to="{ name: 'address' }"
						class="mt-6 hidden w-[100%] md:inline-block md:w-[auto]"
						aria-label="Öffnen der Adresssuche"
					>
						<div
							class="bottom-12 right-8 flex justify-between gap-2 whitespace-nowrap bg-land-red px-4 py-2 text-lg font-bold text-white md:max-w-[480px] md:gap-4 md:px-6 md:text-xl"
						>
							<div>Los, Heizungs-Check starten</div>
							<img src="/assets/img/icons/tabler-icon-menu-item-white.svg" alt="" />
						</div>
					</RouterLink>
				</div>

				<div class="flex-1">
					<img
						alt="EnergieKompass Vorschau"
						class="h-full w-full object-contain"
						src="/assets/img/app_preview.jpg"
					/>
				</div>
			</div>

			<div class="flex flex-col-reverse items-stretch gap-8 md:flex-row md:gap-12 mt-12">
				<div class="flex-1">
					<img
						alt="EnergieKompass Vorschau"
						class="h-full w-full object-contain"
						src="/img/pv_check_preview.jpg"
					/>
				</div>

				<div class="flex-1">
					<h4 class="mb-4 text-3xl">PV-Check</h4>

					<AppText id="TBS33" class="block text-lg md:text-lg" />

					<div class="flex w-full">
						<RouterLink
							:to="{ name: 'address' }"
							class="mt-6 w-[100%] md:inline-block md:w-[auto]"
							aria-label="Öffnen der Adresssuche"
						>
							<div
								class="bottom-12 right-8 flex justify-between gap-2 whitespace-nowrap bg-land-red px-4 py-2 text-lg font-bold text-white md:max-w-[480px] md:gap-4 md:px-6 md:text-xl"
							>
								<div>Los, PV-Check starten</div>
								<img src="/assets/img/icons/tabler-icon-menu-item-white.svg" alt="" />
							</div>
						</RouterLink>
					</div>
				</div>
			</div>

			<div class="flex flex-col items-stretch gap-8 md:flex-row md:gap-12 mt-12">
				<div class="flex-1">
					<h4 class="mb-4 text-3xl">Energiegemeinschaften</h4>

					<AppText id="TBS36" class="block text-lg md:text-lg" />

					<a
						href="https://stromverbindet.energiegemeinschaften.gv.at/"
						target="_blank"
						rel="noopener noreferrer"
						class="mt-6 w-[100%] md:inline-block md:w-[auto]"
						aria-label="Offnen der Energiegemeinschafts-Suche"
					>
						<div
							class="bottom-12 right-8 flex justify-between gap-2 whitespace-nowrap bg-land-red px-4 py-2 text-lg font-bold text-white md:max-w-[480px] md:gap-4 md:px-6 md:text-xl"
						>
							<div>Los, Energiegemeinschaft suchen</div>
							<img src="/assets/img/icons/tabler-icon-menu-item-white.svg" alt="" />
						</div>
					</a>
				</div>

				<div class="flex-1">
					<img
						alt="Energiegemeinschaften Vorschau"
						class="h-full w-full object-contain object-cover"
						src="/assets/img/energie-gemeinschaften.jpg"
					/>
				</div>
			</div>

			<h4 class="pb-4 pt-8 text-2xl md:pb-6">Zukünftige Funktionen des EnergieKompass</h4>
			<AppText id="TBS27" class="mb-4 block text-lg md:text-lg" />
		</section>

		<section class="border-t-48 border-[--background] -mx-4 md:-mx-10">
			<Gallery />
		</section>
	</div>
</template>
